/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { isValid, parse } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';
import { DataType } from '../../DataType';
import { FFuncScalar } from '../FormulaFunc';
export class DATEPARSE extends FFuncScalar {
    constructor(args) {
        super('DATEPARSE', args);
    }
    getReturnType(argTypes) {
        return DataType.DATETIME;
    }
    value(scope, ...args) {
        const dateStr = String(args[1](scope));
        const formatStr = String(args[0](scope));
        const parsed = parse(dateStr, formatStr, new Date());
        if (isValid(parsed)) {
            return fromZonedTime(parsed, 'Z').getTime();
        }
        return null;
    }
}
export class STR extends FFuncScalar {
    constructor(args) {
        super('STR', args);
    }
    getReturnType(argTypes) {
        return DataType.STRING;
    }
    value(scope, ...args) {
        return args[0](scope).toString();
    }
}
